module.exports = __webpack_public_path__ + "static/media/gsmk_logo.c3686557.svg";